// IIFE + bound marker: safe if the theme editor re-executes this script.
(() => {
  if (document.documentElement.dataset.whyListBound) return;
  document.documentElement.dataset.whyListBound = 'true';

  const ACTIVE_CLASS = 'is-active';

  const setActiveRow = (row) => {
    if (row.classList.contains(ACTIVE_CLASS)) return;
    const list = row.closest('[data-whylist-rows]');
    if (!list) return;

    for (const item of list.querySelectorAll('[data-whylist-row]')) {
      item.classList.remove(ACTIVE_CLASS);
      item.removeAttribute('aria-current');
    }
    row.classList.add(ACTIVE_CLASS);
    row.setAttribute('aria-current', 'true');
  };

  // Delegated, so editor-replaced rows need no rebinding.
  const handleRowEvent = (event) => {
    if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
    const row = event.target.closest?.('[data-whylist-row]');
    if (row) setActiveRow(row);
  };

  document.addEventListener('pointerover', handleRowEvent, { passive: true });
  document.addEventListener('focusin', handleRowEvent);
  document.addEventListener('click', handleRowEvent);
})();
